import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useState, useEffect, useContext } from 'react';
import cx from 'classnames';
import range from "lodash/range";
import { getFormattedMonthsForLocale, TranslatorContext } from '@jutro/locale';
import { addMonths, subMonths, setMonth, setYear } from 'date-fns';
import { DropdownSelectField } from '../DropdownSelectField/DropdownSelectField';
import { Icon } from '../../Icon/Icon';
import datePickerStyles from "./DatePickerField.module.css";
import { messages } from './DateField.messages';
export const CustomHeader = ({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  locale,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  minYear,
  maxYear
}) => {
  const _useState = useState(date),
    _useState2 = _slicedToArray(_useState, 2),
    displayedMonth = _useState2[0],
    setDisplayedMonth = _useState2[1];
  const translator = useContext(TranslatorContext);
  useEffect(() => {
    setDisplayedMonth(date);
  }, [date]);
  const listOfMonths = getFormattedMonthsForLocale(locale);
  const setNextMonth = () => setDisplayedMonth(addMonths(displayedMonth, 1));
  const setPreviousMonth = () => setDisplayedMonth(subMonths(displayedMonth, 1));
  const onMonthChange = value => {
    setDisplayedMonth(setMonth(displayedMonth, value));
    changeMonth(value);
  };
  const onYearChange = value => {
    setDisplayedMonth(setYear(displayedMonth, value));
    changeYear(value);
  };
  const onNextMonthClicked = () => {
    increaseMonth();
    setNextMonth();
  };
  const onPreviousMonthClicked = () => {
    decreaseMonth();
    setPreviousMonth();
  };
  const navigationIconPrevClassName = cx(datePickerStyles.navigationPrevious, {
    [datePickerStyles.navigationPreviousDisabled]: prevMonthButtonDisabled
  });
  const navigationIconNextClassName = cx(datePickerStyles.navigationNext, {
    [datePickerStyles.navigationNextDisabled]: nextMonthButtonDisabled
  });
  const createMonthOptionsList = listOfValues => {
    return _mapInstanceProperty(listOfValues).call(listOfValues, (item, index) => {
      return {
        name: item,
        code: index
      };
    });
  };
  const createYearOptionsList = listOfValues => {
    return _mapInstanceProperty(listOfValues).call(listOfValues, item => {
      return {
        name: item,
        code: item
      };
    });
  };
  const getAvailableYearValues = () => createYearOptionsList(range(minYear, maxYear + 1));
  const dropdownClassNames = {
    control: datePickerStyles.control,
    controlFocused: datePickerStyles.controlFocused,
    menuList: datePickerStyles.menu,
    option: datePickerStyles.option,
    selectIcon: datePickerStyles.selectIcon
  };
  return React.createElement("div", {
    className: datePickerStyles.dateHeader
  }, React.createElement(Icon, {
    icon: "mi-chevron-left",
    className: navigationIconPrevClassName,
    tag: "button",
    onClick: onPreviousMonthClicked,
    disabled: prevMonthButtonDisabled,
    "aria-label": translator(messages.previous)
  }), React.createElement(DropdownSelectField, {
    className: datePickerStyles.monthDropdownSelect,
    id: "month-dropdown",
    value: displayedMonth.getMonth(),
    availableValues: createMonthOptionsList(listOfMonths),
    internalClassNames: dropdownClassNames,
    showOptional: false,
    onValueChange: onMonthChange,
    usePortal: false
  }), React.createElement(DropdownSelectField, {
    className: datePickerStyles.yearDropdownSelect,
    id: "year-dropdown",
    value: displayedMonth.getFullYear(),
    availableValues: getAvailableYearValues(),
    internalClassNames: dropdownClassNames,
    showOptional: false,
    onValueChange: onYearChange,
    usePortal: false,
    searchable: true
  }), React.createElement(Icon, {
    icon: "mi-chevron-right",
    className: navigationIconNextClassName,
    tag: "button",
    onClick: onNextMonthClicked,
    disabled: nextMonthButtonDisabled,
    "aria-label": translator(messages.next)
  }));
};
CustomHeader.__docgenInfo = {
  componentName: "CustomHeader",
  packageName: "@jutro/components",
  description: "Custom header component for the DatePicker.",
  displayName: "CustomHeader",
  methods: [],
  actualName: "CustomHeader"
};